// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,import_extension=js"
// @generated from file vitesse/v1/dashboard.proto (package vitesse.v1, syntax proto3)
/* eslint-disable */
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_vitesse_v1_common } from "./common_pb.js";
import { file_vitesse_v1_entitlements } from "./entitlements_pb.js";
/**
 * Describes the file vitesse/v1/dashboard.proto.
 */
export const file_vitesse_v1_dashboard = /*@__PURE__*/ fileDesc("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", [file_vitesse_v1_common, file_vitesse_v1_entitlements]);
/**
 * Describes the message vitesse.v1.DashboardSummary.
 * Use `create(DashboardSummarySchema)` to create a new message.
 */
export const DashboardSummarySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_dashboard, 0);
/**
 * Describes the message vitesse.v1.DashboardTile.
 * Use `create(DashboardTileSchema)` to create a new message.
 */
export const DashboardTileSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_dashboard, 1);
/**
 * Describes the message vitesse.v1.DashboardBackground.
 * Use `create(DashboardBackgroundSchema)` to create a new message.
 */
export const DashboardBackgroundSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_dashboard, 2);
/**
 * Describes the message vitesse.v1.Dashboard.
 * Use `create(DashboardSchema)` to create a new message.
 */
export const DashboardSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_dashboard, 3);
/**
 * Describes the message vitesse.v1.DashboardsSubscribeRequest.
 * Use `create(DashboardsSubscribeRequestSchema)` to create a new message.
 */
export const DashboardsSubscribeRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_dashboard, 4);
/**
 * Describes the message vitesse.v1.DashboardEvent.
 * Use `create(DashboardEventSchema)` to create a new message.
 */
export const DashboardEventSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_dashboard, 5);
/**
 * Describes the message vitesse.v1.GetDashboardRequest.
 * Use `create(GetDashboardRequestSchema)` to create a new message.
 */
export const GetDashboardRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_dashboard, 6);
/**
 * Describes the message vitesse.v1.GetDashboardReply.
 * Use `create(GetDashboardReplySchema)` to create a new message.
 */
export const GetDashboardReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_dashboard, 7);
/**
 * Describes the message vitesse.v1.CreateDashboardRequest.
 * Use `create(CreateDashboardRequestSchema)` to create a new message.
 */
export const CreateDashboardRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_dashboard, 8);
/**
 * Describes the message vitesse.v1.CreateDashboardReply.
 * Use `create(CreateDashboardReplySchema)` to create a new message.
 */
export const CreateDashboardReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_dashboard, 9);
/**
 * Describes the message vitesse.v1.SaveDashboardRequest.
 * Use `create(SaveDashboardRequestSchema)` to create a new message.
 */
export const SaveDashboardRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_dashboard, 10);
/**
 * Describes the message vitesse.v1.SaveDashboardReply.
 * Use `create(SaveDashboardReplySchema)` to create a new message.
 */
export const SaveDashboardReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_dashboard, 11);
/**
 * Describes the message vitesse.v1.DashboardActivityEntry.
 * Use `create(DashboardActivityEntrySchema)` to create a new message.
 */
export const DashboardActivityEntrySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_dashboard, 12);
/**
 * Describes the message vitesse.v1.GetDashboardActivityRequest.
 * Use `create(GetDashboardActivityRequestSchema)` to create a new message.
 */
export const GetDashboardActivityRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_dashboard, 13);
/**
 * Describes the message vitesse.v1.GetDashboardActivityReply.
 * Use `create(GetDashboardActivityReplySchema)` to create a new message.
 */
export const GetDashboardActivityReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_dashboard, 14);
/**
 * Describes the message vitesse.v1.DeleteDashboardRequest.
 * Use `create(DeleteDashboardRequestSchema)` to create a new message.
 */
export const DeleteDashboardRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_dashboard, 15);
/**
 * Describes the message vitesse.v1.DeleteDashboardReply.
 * Use `create(DeleteDashboardReplySchema)` to create a new message.
 */
export const DeleteDashboardReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_dashboard, 16);
/**
 * Describes the message vitesse.v1.ShareRead.
 * Use `create(ShareReadSchema)` to create a new message.
 */
export const ShareReadSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_dashboard, 17);
/**
 * Describes the message vitesse.v1.ShareCommand.
 * Use `create(ShareCommandSchema)` to create a new message.
 */
export const ShareCommandSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_dashboard, 18);
/**
 * Describes the message vitesse.v1.ShareScope.
 * Use `create(ShareScopeSchema)` to create a new message.
 */
export const ShareScopeSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_dashboard, 19);
/**
 * Describes the message vitesse.v1.ShareTerms.
 * Use `create(ShareTermsSchema)` to create a new message.
 */
export const ShareTermsSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_dashboard, 20);
/**
 * Describes the message vitesse.v1.ShareRecipient.
 * Use `create(ShareRecipientSchema)` to create a new message.
 */
export const ShareRecipientSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_dashboard, 21);
/**
 * Describes the message vitesse.v1.ShareDashboardRequest.
 * Use `create(ShareDashboardRequestSchema)` to create a new message.
 */
export const ShareDashboardRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_dashboard, 22);
/**
 * Describes the message vitesse.v1.ShareDashboardReply.
 * Use `create(ShareDashboardReplySchema)` to create a new message.
 */
export const ShareDashboardReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_dashboard, 23);
/**
 * Describes the message vitesse.v1.RevokeShareRequest.
 * Use `create(RevokeShareRequestSchema)` to create a new message.
 */
export const RevokeShareRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_dashboard, 24);
/**
 * Describes the message vitesse.v1.RevokeShareReply.
 * Use `create(RevokeShareReplySchema)` to create a new message.
 */
export const RevokeShareReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_dashboard, 25);
/**
 * Describes the message vitesse.v1.ListSharesRequest.
 * Use `create(ListSharesRequestSchema)` to create a new message.
 */
export const ListSharesRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_dashboard, 26);
/**
 * Describes the message vitesse.v1.ShareListing.
 * Use `create(ShareListingSchema)` to create a new message.
 */
export const ShareListingSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_dashboard, 27);
/**
 * Describes the message vitesse.v1.ListSharesReply.
 * Use `create(ListSharesReplySchema)` to create a new message.
 */
export const ListSharesReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_dashboard, 28);
/**
 * Describes the message vitesse.v1.OpenShareRequest.
 * Use `create(OpenShareRequestSchema)` to create a new message.
 */
export const OpenShareRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_dashboard, 29);
/**
 * Describes the message vitesse.v1.OpenShareReply.
 * Use `create(OpenShareReplySchema)` to create a new message.
 */
export const OpenShareReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_dashboard, 30);
/**
 * Describes the message vitesse.v1.DashboardShare.
 * Use `create(DashboardShareSchema)` to create a new message.
 */
export const DashboardShareSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_dashboard, 31);
/**
 * Describes the message vitesse.v1.DashboardShare.Recipient.
 * Use `create(DashboardShare_RecipientSchema)` to create a new message.
 */
export const DashboardShare_RecipientSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_dashboard, 31, 0);
/**
 * @generated from enum vitesse.v1.BackgroundFit
 */
export var BackgroundFit;
(function (BackgroundFit) {
    /**
     * * Fill the board, cropping the overflow. The default, because a background
     *  is atmosphere and a letterboxed one reads as a mistake.
     *
     * @generated from enum value: BACKGROUND_FIT_COVER = 0;
     */
    BackgroundFit[BackgroundFit["COVER"] = 0] = "COVER";
    /**
     * * Fit the whole image, leaving margins. For a diagram or a plan view, where
     *  cropping would remove the part that mattered.
     *
     * @generated from enum value: BACKGROUND_FIT_CONTAIN = 1;
     */
    BackgroundFit[BackgroundFit["CONTAIN"] = 1] = "CONTAIN";
    /**
     * * Repeat it. For a texture, where the image is a pattern rather than a picture.
     *
     * @generated from enum value: BACKGROUND_FIT_TILE = 2;
     */
    BackgroundFit[BackgroundFit["TILE"] = 2] = "TILE";
})(BackgroundFit || (BackgroundFit = {}));
/**
 * Describes the enum vitesse.v1.BackgroundFit.
 */
export const BackgroundFitSchema = /*@__PURE__*/ enumDesc(file_vitesse_v1_dashboard, 0);
/**
 *
 * A SHARE — a board that leaves the app.
 *
 * THE SNAPSHOT IS THE GRANT. A share freezes the board's composition (its tiles as
 * they were) and the scope of what a viewer may read is DERIVED from that frozen
 * composition, never authored beside it: a tile added to the board tomorrow cannot
 * widen a link handed out today, and a share can never reach a symbol the board
 * did not show. Values stay live; only the composition is frozen.
 *
 * THE TOKEN IS OPAQUE. What a viewer holds is `vs1.<gateway>.<share>.<secret>`; the
 * gateway keeps only the secret's hash on the record and answers "may this token
 * see this" by lookup, on the box and on the cloud mirror alike. No key travels,
 * revocation is a field on the record, and the LAN-versus-cloud race a member's
 * board rides works unchanged for a share.
 *
 * A public link may look, never touch, and always expires; an invite names its
 * recipients, who sign in as themselves (an account in no org is enough), may be
 * revoked one at a time, and may be given the board's buttons.
 *
 * @generated from enum vitesse.v1.ShareAudience
 */
export var ShareAudience;
(function (ShareAudience) {
    /**
     * @generated from enum value: SHARE_AUDIENCE_UNSPECIFIED = 0;
     */
    ShareAudience[ShareAudience["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * * Anyone holding the link. Bearer access: read-only, expiry required.
     *
     * @generated from enum value: SHARE_AUDIENCE_LINK = 1;
     */
    ShareAudience[ShareAudience["LINK"] = 1] = "LINK";
    /**
     * * Named emails, each signed in as themselves.
     *
     * @generated from enum value: SHARE_AUDIENCE_INVITE = 2;
     */
    ShareAudience[ShareAudience["INVITE"] = 2] = "INVITE";
})(ShareAudience || (ShareAudience = {}));
/**
 * Describes the enum vitesse.v1.ShareAudience.
 */
export const ShareAudienceSchema = /*@__PURE__*/ enumDesc(file_vitesse_v1_dashboard, 1);
/**
 * @generated from service vitesse.v1.Dashboards
 */
export const Dashboards = /*@__PURE__*/ serviceDesc(file_vitesse_v1_dashboard, 0);
//# sourceMappingURL=dashboard_pb.js.map